import { ENavigation, TNavigation } from 'shared/types/navigation';

const SCROLL_PARAM = '?scrollTo=';

const CORE_BUSINESS_URL_WITH_SCROLL = `/ir-edu/core_business${SCROLL_PARAM}`;

const TRANSACTIONAL_BUSINESS_URL_WITH_SCROLL = `/ir-edu/transactional_business${SCROLL_PARAM}`;

const DAILY_RENT_URL_WITH_SCROLL = `/ir-edu/posutochno${SCROLL_PARAM}`;

const CIAN_KEY_TECHNOLOGIES_WITH_SCROLL = `/ir-edu/key_technologies${SCROLL_PARAM}`;

export const NAVIGATION: TNavigation[] = [
  {
    name: 'Технологии Циан',
    url: '/ir-edu/key_technologies',
    links: [
      {
        urls: [
          {
            text: 'ИИ в поиске и размещении объявлений',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.AiInSearch}`,
          },
          {
            text: 'Сервисы для собственников и агентов',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.ServicesOwners}`,
          },
          {
            text: 'Сервисы для покупателей',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.ServicesBuyers}`,
          },
          {
            text: 'Модерация базы',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.DatabaseModeration}`,
          },
          {
            text: 'Девелоперам и финансовым организациям',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.ForDevelopers}`,
          },
          {
            text: 'Кибербезопасность',
            url: `${CIAN_KEY_TECHNOLOGIES_WITH_SCROLL + ENavigation.Cybersecurity}`,
          },
        ],
      },
    ],
  },
  {
    name: 'Основной бизнес',
    url: '/ir-edu/core_business',
    links: [
      {
        title: { text: 'Вторичный рынок', url: `${CORE_BUSINESS_URL_WITH_SCROLL}${ENavigation.SecondaryMarket}` },
        urls: [
          {
            text: 'Размещение объявлений на Циан',
            url: `${CORE_BUSINESS_URL_WITH_SCROLL}${ENavigation.AdPlacement}`,
          },
          {
            text: 'Услуги продвижения',
            url: `${CORE_BUSINESS_URL_WITH_SCROLL}${ENavigation.PaidServices}`,
          },
          {
            text: 'Преимущества СРТ-модели для бизнеса',
            url: `${CORE_BUSINESS_URL_WITH_SCROLL}${ENavigation.BenefitsCpt}`,
          },
        ],
      },
      {
        title: { text: 'Первичный рынок', url: `${CORE_BUSINESS_URL_WITH_SCROLL}${ENavigation.FirstMarket}` },
        urls: [
          {
            text: 'Лидогенерация',
            url: `${CORE_BUSINESS_URL_WITH_SCROLL + ENavigation.LeadGeneration}`,
          },
          {
            text: 'Медийная реклама',
            url: `${CORE_BUSINESS_URL_WITH_SCROLL + ENavigation.MediaAd}`,
          },
        ],
      },
    ],
  },
  {
    name: 'Транзакционный бизнес',
    url: '/ir-edu/transactional_business',
    links: [
      {
        urls: [
          {
            text: 'Финансовая платформа',
            url: `${TRANSACTIONAL_BUSINESS_URL_WITH_SCROLL + ENavigation.FinPlatform}`,
          },
          {
            text: 'Онлайн-договор',
            url: `${TRANSACTIONAL_BUSINESS_URL_WITH_SCROLL + ENavigation.OnlineContract}`,
          },
          {
            text: 'SmartDeal',
            url: `${TRANSACTIONAL_BUSINESS_URL_WITH_SCROLL + ENavigation.SmartDeal}`,
          },
          {
            text: 'Электронная регистрация',
            url: `${TRANSACTIONAL_BUSINESS_URL_WITH_SCROLL + ENavigation.ElReg}`,
          },
        ],
      },
    ],
  },
  {
    name: 'Посуточная аренда',
    url: '/ir-edu/posutochno',
    links: [
      {
        urls: [
          {
            text: 'Особенности сервиса',
            url: `${DAILY_RENT_URL_WITH_SCROLL + ENavigation.ServiceFeatures}`,
          },
          {
            text: 'OTA-модель',
            url: `${DAILY_RENT_URL_WITH_SCROLL + ENavigation.OtaModel}`,
          },
          {
            text: 'Преимущества Циан.Посуточно',
            url: `${DAILY_RENT_URL_WITH_SCROLL + ENavigation.AdvantagesDaily}`,
          },
        ],
      },
    ],
  },
];
